import { InvoiceDeposit } from '@/types'

const roundCents = (amount: number) => Math.round((amount + Number.EPSILON) * 100) / 100

// A rate applied to a basis lands on a half cent often enough (10%, 5,5%, 2,1%) that the rounding has to happen on
// cents: rounding the euros through a float would send some of those half cents down, where the server sends them up.
const taxOn = (basis: number, rate: number) => Math.round(basis * rate) / 100

// Mirrors Invoice#vat_breakdown: VAT is computed per rate on the sum of the lines, rounded half up to the cent.
export function invoiceTotals(deposits: Pick<InvoiceDeposit, 'price' | 'vat_rate'>[]) {
  const bases = new Map<number, number>()
  deposits.forEach((deposit) => {
    const rate = Number(deposit.vat_rate)
    bases.set(rate, roundCents((bases.get(rate) ?? 0) + Number(deposit.price)))
  })
  const excludingTax = roundCents([...bases.values()].reduce((sum, basis) => sum + basis, 0))
  const tax = roundCents([...bases.entries()].reduce((sum, [rate, basis]) => sum + taxOn(basis, rate), 0))
  return { excludingTax, tax, includingTax: roundCents(excludingTax + tax) }
}
